import angular from 'angular';
import UserFactory from './user.factory';

let userModule = angular.module('user', [])

  .factory('User', UserFactory)

  .name;

export default userModule;


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/common/user/user.js
 **/